import { createSelector } from '@reduxjs/toolkit';
import { ERoomType } from '../../../packages/JsonQuery';
import { selectCountersByDealType } from './selectCountersByDealType';

export const selectRoomTypeOptions = createSelector(selectCountersByDealType, counters => [
  { label: 'Все квартиры', value: 'all', counter: getCounterValue(counters?.['total']) },
  { label: 'Студии', value: ERoomType.Studio, counter: getCounterValue(counters?.['studios']) },
  { label: '1-комн.', value: ERoomType.FlatOneRoom, counter: getCounterValue(counters?.['oneRoom']) },
  { label: '2-комн.', value: ERoomType.FlatTwoRooms, counter: getCounterValue(counters?.['twoRoom']) },
  { label: '3-комн.', value: ERoomType.FlatThreeRooms, counter: getCounterValue(counters?.['threeRoom']) },
  { label: '4-комн.', value: ERoomType.FlatFourRooms, counter: getCounterValue(counters?.['fourRoom']) },
  { label: 'Свободная планировка', value: ERoomType.FlatFreeLayout, counter: getCounterValue(counters?.['openPlan']) },
]);

function getCounterValue(value?: number) {
  return value || 0;
}
